import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import '../Styles/CheckoutPayment.css';

const CheckoutSuccess = () => {
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get('session_id');
    const [isProcessing, setIsProcessing] = useState(true);
    const [emailsSent, setEmailsSent] = useState(false);

    useEffect(() => {
        const handlePaymentSuccess = async () => {
            try {
                const bookingId = sessionStorage.getItem('lastBookingId');

                if (bookingId && sessionId) {
                    const response = await fetch(
                        `${process.env.REACT_APP_API_URL}/api/checkout/payment-success`,
                        {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({ bookingId }),
                            keepalive: true
                        }
                    );

                    const data = await response.json();

                    if (data.emailsSent) {
                        setEmailsSent(true);
                    }

                    sessionStorage.removeItem('checkoutSessionUrl');
                    sessionStorage.removeItem('checkoutSession');
                    sessionStorage.removeItem('lastBookingId');
                    sessionStorage.removeItem('bookingStatus');
                } else {
                    setEmailsSent(false);
                }
            } catch (err) {
                setEmailsSent(false);
            } finally {
                setTimeout(() => {
                    setIsProcessing(false);
                }, 300);
            }
        };

        handlePaymentSuccess();
    }, [sessionId]);

    return (
        <div className="checkout-payment-container success">
            <div className="payment-card">
                {isProcessing ? (
                    // Loading State
                    <>
                        <div className="loading-spinner">
                            <svg
                                className="spinner-icon"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <circle cx="12" cy="12" r="10"></circle>
                                <path d="M12 6v6l4 2"></path>
                            </svg>
                        </div>
                        <h1>Processing Your Booking</h1>
                        <p className="subtitle">Confirming payment...</p>
                        <p style={{ marginTop: '15px', fontSize: '14px', color: '#888' }}>
                            Confirmation emails are being sent in the background.
                        </p>
                    </>
                ) : (
                    // Success State
                    <>
                        <div className="success-icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                        </div>

                        <h1>Payment Successful!</h1>
                        <p className="subtitle">Your booking is confirmed</p>

                        <div className="message-content">
                            <p>
                                Payment successful! Your booking has been confirmed.
                            </p>
                            <p style={{ marginTop: '20px', fontSize: '16px', color: '#666' }}>
                                You can close this window.
                            </p>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default CheckoutSuccess;
